import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../pages/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPlus, 
    faBox, 
    faTag, 
    faIndustry, 
    faSave, 
    faTimes, 
    faSpinner, 
    faCheckCircle, 
    faExclamationTriangle,
    faStore,
    faExchangeAlt,
    faChevronDown,
    faList,
    faFileAlt,
    faCopy,
    faTrashAlt,
    faArrowLeft,
    faSearch,
    faBarcode,
    faFilter,
    faEdit,
    faEye,
    faDownload,
    faUpload,
    faFileCsv,
    faInfoCircle,
    faMagic,
    faBuilding,
    faListUl,
    faLayerGroup
} from '@fortawesome/free-solid-svg-icons';
import "../module_mechanics/Styles/Form.css";

// Create translator instance
const createItemTranslator = () => {
    let cache = new Map();
    let preloadedLanguages = new Set(['en', 'ur', 'ar', 'es']);

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found in Pharmacy Item Form");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Add Item': 'آئٹم شامل کریں',
                'Fill in the item details below': 'نیچے آئٹم کی تفصیلات بھریں',
                'Item Code': 'آئٹم کوڈ',
                'Item Name': 'آئٹم کا نام',
                'Manufacturer': 'مینوفیکچرر',
                'Category': 'کیٹیگری',
                'Item Type': 'آئٹم کی قسم',
                'Select a category': 'کیٹیگری منتخب کریں',
                'Save Item': 'آئٹم محفوظ کریں',
                'Clear': 'صاف کریں',
                'Adding...': 'شامل کر رہے ہیں...',
                'Item saved successfully!': 'آئٹم کامیابی سے محفوظ ہو گیا!',
                'Failed to save item': 'آئٹم محفوظ کرنے میں ناکامی',
                'Network error occurred': 'نیٹ ورک کی خرابی',
                'Item code is required': 'آئٹم کوڈ ضروری ہے',
                'Item name is required': 'آئٹم کا نام ضروری ہے',
                'Item code already exists': 'آئٹم کوڈ پہلے سے موجود ہے',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Select a shop first': 'پہلے ایک شاپ منتخب کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Switch Shop': 'شاپ تبدیل کریں',
                'Shop switched successfully': 'شاپ کامیابی سے تبدیل ہو گئی',
                'Failed to switch shop': 'شاپ تبدیل کرنے میں ناکامی',
                'Loading shops...': 'شاپس لوڈ ہو رہی ہیں...',
                'No shops available': 'کوئی شاپ دستیاب نہیں',
                'Current': 'موجودہ',
                'Optional': 'اختیاری',
                'Items List': 'آئٹمز کی فہرست',
                'Bulk Add': 'بلک شامل کریں',
                'Search Items': 'آئٹمز تلاش کریں',
                'Search': 'تلاش کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'Are you sure you want to delete this item?': 'کیا آپ اس آئٹم کو حذف کرنا چاہتے ہیں؟',
                'Delete Item': 'آئٹم حذف کریں',
                'Item deleted successfully': 'آئٹم کامیابی سے حذف ہو گیا',
                'Failed to delete item': 'آئٹم حذف کرنے میں ناکامی',
                'No items found': 'کوئی آئٹم نہیں ملا',
                'Draft saved': 'ڈرافٹ محفوظ ہو گیا',
                'Draft loaded': 'ڈرافٹ لوڈ ہو گیا',
                'Draft cleared': 'ڈرافٹ صاف ہو گیا',
                'Save Draft': 'ڈرافٹ محفوظ کریں',
                'Drafts': 'ڈرافٹس',
                'View Drafts': 'ڈرافٹس دیکھیں',
                'No drafts saved': 'کوئی ڈرافٹ محفوظ نہیں',
                'Auto Generate': 'آٹو جنریٹ',
                'CSV Upload': 'سی ایس وی اپ لوڈ',
                'Download CSV Format': 'سی ایس وی فارمیٹ ڈاؤن لوڈ کریں',
                'Upload CSV File': 'سی ایس وی فائل اپ لوڈ کریں',
                'Instructions': 'ہدایات',
                'Item name only - code will be auto-generated': 'صرف آئٹم کا نام - کوڈ خودکار جنریٹ ہوگا',
                'Uploading...': 'اپ لوڈ ہو رہا ہے...',
                'Items added successfully': 'آئٹمز کامیابی سے شامل ہو گئے',
                'Failed to upload items': 'آئٹمز اپ لوڈ کرنے میں ناکامی',
                'Please select a CSV file': 'براہ کرم سی ایس وی فائل منتخب کریں',
                'Invalid CSV format': 'غلط سی ایس وی فارمیٹ',
                'Code auto-generated from item name': 'کوڈ آئٹم کے نام سے خودکار جنریٹ ہوا',
                'Select manufacturer': 'مینوفیکچرر منتخب کریں',
                'Type to search manufacturer...': 'مینوفیکچرر تلاش کریں...',
                'No manufacturers found': 'کوئی مینوفیکچرر نہیں ملا',
                'Type to search category...': 'کیٹیگری تلاش کریں...',
                'No categories found': 'کوئی کیٹیگری نہیں ملی',
                'Type to search item type...': 'آئٹم کی قسم تلاش کریں...',
                'No item types found': 'کوئی آئٹم کی قسم نہیں ملی',
                'Add custom value': 'اپنی قیمت شامل کریں',
                'Saved Drafts': 'محفوظ شدہ ڈرافٹس',
                'No drafts saved': 'کوئی ڈرافٹ محفوظ نہیں',
                'Clear Form': 'فارم صاف کریں',
                'Save as Draft': 'ڈرافٹ کے طور پر محفوظ کریں',
                'View Drafts': 'ڈرافٹس دیکھیں'
            },
            'ar': {
                'Add Item': 'إضافة عنصر',
                'Fill in the item details below': 'املأ تفاصيل العنصر أدناه',
                'Item Code': 'رمز العنصر',
                'Item Name': 'اسم العنصر',
                'Manufacturer': 'الشركة المصنعة',
                'Category': 'الفئة',
                'Item Type': 'نوع العنصر',
                'Select a category': 'اختر فئة',
                'Save Item': 'حفظ العنصر',
                'Clear': 'مسح',
                'Adding...': 'جاري الإضافة...',
                'Item saved successfully!': 'تم حفظ العنصر بنجاح!',
                'Failed to save item': 'فشل في حفظ العنصر',
                'Network error occurred': 'حدث خطأ في الشبكة',
                'Item code is required': 'رمز العنصر مطلوب',
                'Item name is required': 'اسم العنصر مطلوب',
                'Item code already exists': 'رمز العنصر موجود بالفعل',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Select a shop first': 'اختر متجرًا أولاً',
                'No shop selected': 'لم يتم اختيار متجر',
                'Switch Shop': 'تبديل المتجر',
                'Shop switched successfully': 'تم تبديل المتجر بنجاح',
                'Failed to switch shop': 'فشل في تبديل المتجر',
                'Loading shops...': 'جاري تحميل المتاجر...',
                'No shops available': 'لا توجد متاجر متاحة',
                'Current': 'حالي',
                'Optional': 'اختياري',
                'Items List': 'قائمة العناصر',
                'Bulk Add': 'إضافة جماعية',
                'Search Items': 'بحث عن عناصر',
                'Search': 'بحث',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'Are you sure you want to delete this item?': 'هل أنت متأكد أنك تريد حذف هذا العنصر؟',
                'Delete Item': 'حذف العنصر',
                'Item deleted successfully': 'تم حذف العنصر بنجاح',
                'Failed to delete item': 'فشل في حذف العنصر',
                'No items found': 'لم يتم العثور على عناصر',
                'Draft saved': 'تم حفظ المسودة',
                'Draft loaded': 'تم تحميل المسودة',
                'Draft cleared': 'تم مسح المسودة',
                'Save Draft': 'حفظ المسودة',
                'Drafts': 'المسودات',
                'View Drafts': 'عرض المسودات',
                'No drafts saved': 'لا توجد مسودات محفوظة',
                'Auto Generate': 'توليد تلقائي',
                'CSV Upload': 'رفع CSV',
                'Download CSV Format': 'تحميل تنسيق CSV',
                'Upload CSV File': 'رفع ملف CSV',
                'Instructions': 'تعليمات',
                'Item name only - code will be auto-generated': 'اسم العنصر فقط - سيتم إنشاء الرمز تلقائيًا',
                'Uploading...': 'جاري الرفع...',
                'Items added successfully': 'تم إضافة العناصر بنجاح',
                'Failed to upload items': 'فشل في رفع العناصر',
                'Please select a CSV file': 'الرجاء تحديد ملف CSV',
                'Invalid CSV format': 'تنسيق CSV غير صالح',
                'Code auto-generated from item name': 'تم إنشاء الرمز تلقائيًا من اسم العنصر',
                'Select manufacturer': 'اختر الشركة المصنعة',
                'Type to search manufacturer...': 'اكتب للبحث عن شركة مصنعة...',
                'No manufacturers found': 'لم يتم العثور على شركات مصنعة',
                'Type to search category...': 'اكتب للبحث عن فئة...',
                'No categories found': 'لم يتم العثور على فئات',
                'Type to search item type...': 'اكتب للبحث عن نوع عنصر...',
                'No item types found': 'لم يتم العثور على أنواع عناصر',
                'Add custom value': 'إضافة قيمة مخصصة',
                'Saved Drafts': 'المسودات المحفوظة',
                'No drafts saved': 'لا توجد مسودات محفوظة',
                'Clear Form': 'مسح النموذج',
                'Save as Draft': 'حفظ كمسودة',
                'View Drafts': 'عرض المسودات'
            },
            'es': {
                'Add Item': 'Agregar Artículo',
                'Fill in the item details below': 'Complete los detalles del artículo a continuación',
                'Item Code': 'Código de Artículo',
                'Item Name': 'Nombre del Artículo',
                'Manufacturer': 'Fabricante',
                'Category': 'Categoría',
                'Item Type': 'Tipo de Artículo',
                'Select a category': 'Seleccione una categoría',
                'Save Item': 'Guardar Artículo',
                'Clear': 'Limpiar',
                'Adding...': 'Agregando...',
                'Item saved successfully!': '¡Artículo guardado exitosamente!',
                'Failed to save item': 'Error al guardar el artículo',
                'Network error occurred': 'Ocurrió un error de red',
                'Item code is required': 'El código de artículo es requerido',
                'Item name is required': 'El nombre del artículo es requerido',
                'Item code already exists': 'El código de artículo ya existe',
                'Success': 'Éxito',
                'Error': 'Error',
                'Warning': 'Advertencia',
                'Select a shop first': 'Seleccione una tienda primero',
                'No shop selected': 'No se seleccionó ninguna tienda',
                'Switch Shop': 'Cambiar Tienda',
                'Shop switched successfully': 'Tienda cambiada exitosamente',
                'Failed to switch shop': 'Error al cambiar de tienda',
                'Loading shops...': 'Cargando tiendas...',
                'No shops available': 'No hay tiendas disponibles',
                'Current': 'Actual',
                'Optional': 'Opcional',
                'Items List': 'Lista de Artículos',
                'Bulk Add': 'Agregar Múltiple',
                'Search Items': 'Buscar Artículos',
                'Search': 'Buscar',
                'Edit': 'Editar',
                'Delete': 'Eliminar',
                'Are you sure you want to delete this item?': '¿Estás seguro de que quieres eliminar este artículo?',
                'Delete Item': 'Eliminar Artículo',
                'Item deleted successfully': 'Artículo eliminado exitosamente',
                'Failed to delete item': 'Error al eliminar el artículo',
                'No items found': 'No se encontraron artículos',
                'Draft saved': 'Borrador guardado',
                'Draft loaded': 'Borrador cargado',
                'Draft cleared': 'Borrador limpiado',
                'Save Draft': 'Guardar Borrador',
                'Drafts': 'Borradores',
                'View Drafts': 'Ver Borradores',
                'No drafts saved': 'No hay borradores guardados',
                'Auto Generate': 'Generar Automáticamente',
                'CSV Upload': 'Cargar CSV',
                'Download CSV Format': 'Descargar Formato CSV',
                'Upload CSV File': 'Cargar Archivo CSV',
                'Instructions': 'Instrucciones',
                'Item name only - code will be auto-generated': 'Solo nombre del artículo - el código se generará automáticamente',
                'Uploading...': 'Cargando...',
                'Items added successfully': 'Artículos agregados exitosamente',
                'Failed to upload items': 'Error al cargar artículos',
                'Please select a CSV file': 'Por favor seleccione un archivo CSV',
                'Invalid CSV format': 'Formato CSV inválido',
                'Code auto-generated from item name': 'Código generado automáticamente desde el nombre del artículo',
                'Select manufacturer': 'Seleccionar fabricante',
                'Type to search manufacturer...': 'Escriba para buscar fabricante...',
                'No manufacturers found': 'No se encontraron fabricantes',
                'Type to search category...': 'Escriba para buscar categoría...',
                'No categories found': 'No se encontraron categorías',
                'Type to search item type...': 'Escriba para buscar tipo de artículo...',
                'No item types found': 'No se encontraron tipos de artículo',
                'Add custom value': 'Agregar valor personalizado',
                'Saved Drafts': 'Borradores Guardados',
                'No drafts saved': 'No hay borradores guardados',
                'Clear Form': 'Limpiar Formulario',
                'Save as Draft': 'Guardar como Borrador',
                'View Drafts': 'Ver Borradores'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed, trying MyMemory");
        }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) {
            console.log("MyMemory translation failed");
        }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();

        return translated;
    };

    const defaultTexts = {
        addItem: 'Add Item',
        fillDetails: 'Fill in the item details below',
        itemCode: 'Item Code',
        itemName: 'Item Name',
        manufacturer: 'Manufacturer',
        category: 'Category',
        itemtype: 'Item Type',
        selectCategory: 'Select a category',
        saveItem: 'Save Item',
        clear: 'Clear',
        adding: 'Adding...',
        itemAdded: 'Item saved successfully!',
        failedAdd: 'Failed to save item',
        networkError: 'Network error occurred',
        codeRequired: 'Item code is required',
        nameRequired: 'Item name is required',
        codeExists: 'Item code already exists',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        selectShop: 'Select a shop first',
        noShopSelected: 'No shop selected',
        switchShop: 'Switch Shop',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        optional: 'Optional',
        itemsList: 'Items List',
        bulkAdd: 'Bulk Add',
        searchItems: 'Search Items',
        search: 'Search',
        edit: 'Edit',
        delete: 'Delete',
        deleteConfirm: 'Are you sure you want to delete this item?',
        deleteItem: 'Delete Item',
        itemDeleted: 'Item deleted successfully',
        failedDelete: 'Failed to delete item',
        noItems: 'No items found',
        draftSaved: 'Draft saved',
        draftLoaded: 'Draft loaded',
        draftCleared: 'Draft cleared',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        viewDrafts: 'View Drafts',
        noDraftsSaved: 'No drafts saved',
        autoGenerate: 'Auto Generate',
        csvUpload: 'CSV Upload',
        downloadCSVFormat: 'Download CSV Format',
        uploadCSVFile: 'Upload CSV File',
        instructions: 'Instructions',
        itemNameOnly: 'Item name only - code will be auto-generated',
        uploading: 'Uploading...',
        itemsAddedSuccess: 'Items added successfully',
        failedUpload: 'Failed to upload items',
        selectCSVFile: 'Please select a CSV file',
        invalidCSV: 'Invalid CSV format',
        codeAutoGenerated: 'Code auto-generated from item name',
        selectManufacturer: 'Select manufacturer',
        searchManufacturer: 'Type to search manufacturer...',
        noManufacturers: 'No manufacturers found',
        searchCategory: 'Type to search category...',
        noCategories: 'No categories found',
        searchItemType: 'Type to search item type...',
        noItemTypes: 'No item types found',
        addCustomValue: 'Add custom value',
        savedDrafts: 'Saved Drafts',
        clearForm: 'Clear Form',
        saveAsDraft: 'Save as Draft',
        noDrafts: 'No drafts saved'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const itemTranslator = createItemTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// Items List Modal
const ItemsListModal = ({ isOpen, onClose, items, translations, onEdit, onDelete, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozui_modal-overlay ozui_modal-lg" onClick={onClose}>
            <div className="ozui_modal" onClick={e => e.stopPropagation()}>
                <div className="ozui_modal-header">
                    <h3>{translations.itemsList || 'Items List'}</h3>
                    <button className="ozui_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui_modal-body">
                    {loading ? (
                        <div className="ozui_loading-state">Loading items...</div>
                    ) : items.length === 0 ? (
                        <div className="ozui_empty-state">{translations.noItems || 'No items found'}</div>
                    ) : (
                        <div className="ozui_items-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{translations.itemCode || 'Code'}</th>
                                        <th>{translations.itemName || 'Name'}</th>
                                        <th>{translations.manufacturer || 'Manufacturer'}</th>
                                        <th>{translations.category || 'Category'}</th>
                                        <th>{translations.itemtype || 'Item Type'}</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item) => (
                                        <tr key={item.id}>
                                            <td><span className="ozui_item-code">{item.itemcode}</span></td>
                                            <td>{item.itemname}</td>
                                            <td>{item.manufacturer || '-'}</td>
                                            <td>{item.category || '-'}</td>
                                            <td>{item.itemtype || '-'}</td>
                                            <td>
                                                <button 
                                                    className="ozui_action-btn ozui_edit-btn"
                                                    onClick={() => onEdit(item)}
                                                    title="Edit"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button 
                                                    className="ozui_action-btn ozui_delete-btn"
                                                    onClick={() => onDelete(item.id)}
                                                    title="Delete"
                                                >
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// CSV Upload Modal
const CSVUploadModal = ({ isOpen, onClose, onUpload, translations, loading }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewData, setPreviewData] = useState([]);
    const fileInputRef = useRef(null);

    const showToast = useCallback((type, message) => {
        if (window.toastFunction) {
            window.toastFunction(type, message);
        }
    }, []);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        setSelectedFile(file);
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const text = event.target.result;
                const lines = text.split('\n').filter(line => line.trim());
                const dataLines = lines.slice(0, 5);
                const preview = dataLines.map(line => {
                    const parts = line.split(',').map(s => s.trim());
                    if (parts.length === 1) {
                        return { 
                            itemname: parts[0] || '',
                            manufacturer: '',
                            category: '',
                            itemtype: '',
                            itemcode: ''
                        };
                    } else {
                        return {
                            itemcode: parts[0] || '',
                            itemname: parts[1] || '',
                            manufacturer: parts[2] || '',
                            category: parts[3] || '',
                            itemtype: parts[4] || ''
                        };
                    }
                }).filter(item => item.itemname);
                setPreviewData(preview);
            } catch (error) {
                showToast('error', translations.invalidCSV || 'Invalid CSV format');
            }
        };
        reader.readAsText(file);
    };

    const handleUpload = () => {
        if (!selectedFile) {
            showToast('warning', translations.selectCSVFile || 'Please select a CSV file');
            return;
        }
        onUpload(selectedFile);
    };

    useEffect(() => {
        if (!isOpen) {
            setSelectedFile(null);
            setPreviewData([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="ozui_modal-overlay ozui_modal-lg" onClick={onClose}>
            <div className="ozui_modal" onClick={e => e.stopPropagation()}>
                <div className="ozui_modal-header">
                    <h3>
                        <FontAwesomeIcon icon={faFileCsv} style={{ marginRight: '8px' }} />
                        {translations.csvUpload || 'CSV Upload'}
                    </h3>
                    <button className="ozui_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui_modal-body">
                    <div className="ozui_csv-instructions">
                        <div className="ozui_csv-instructions-header">
                            <FontAwesomeIcon icon={faInfoCircle} />
                            <strong>{translations.instructions || 'Instructions'}</strong>
                        </div>
                        <ul className="ozui_csv-instructions-list">
                            <li>Format: <strong>itemcode, itemname, manufacturer, category, itemtype</strong></li>
                            <li>Only <strong>itemname</strong> is required - others are optional</li>
                            <li>If itemcode is not provided, it will be auto-generated</li>
                            <li>Each item on a new line</li>
                        </ul>
                    </div>

                    <div className="ozui_csv-download-section">
                        <button 
                            className="ozui_csv-download-btn"
                            onClick={() => {
                                const csvContent = 'itemcode,itemname,manufacturer,category,itemtype\nMED001,Paracetamol 500mg,GSK,Pain Relief,Tablet\nMED002,Ibuprofen 400mg,Pfizer,Pain Relief,Capsule\nMED003,Amoxicillin 250mg,Novartis,Antibiotics,Syrup\nMED004,Vitamin C 1000mg,Bayer,Vitamins & Supplements,Tablet\nMED005,Cetirizine 10mg,J&J,Antihistamines,Tablet';
                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = 'pharmacy_items_template.csv';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(link.href);
                            }}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            {translations.downloadCSVFormat || 'Download CSV Format'}
                        </button>
                    </div>

                    <div className="ozui_csv-upload-section">
                        <div className="ozui_csv-drop-zone" onClick={() => fileInputRef.current?.click()}>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept=".csv"
                                onChange={handleFileSelect}
                                style={{ display: 'none' }}
                            />
                            <FontAwesomeIcon icon={faUpload} className="ozui_csv-upload-icon" />
                            <p>{selectedFile ? selectedFile.name : (translations.uploadCSVFile || 'Click to upload CSV file')}</p>
                            {selectedFile && <span className="ozui_csv-file-size">({(selectedFile.size / 1024).toFixed(1)} KB)</span>}
                        </div>

                        {previewData.length > 0 && (
                            <div className="ozui_csv-preview">
                                <h4>Preview ({previewData.length} items)</h4>
                                <div className="ozui_csv-preview-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{translations.itemCode || 'Code'}</th>
                                                <th>{translations.itemName || 'Name'}</th>
                                                <th>{translations.manufacturer || 'Manufacturer'}</th>
                                                <th>{translations.category || 'Category'}</th>
                                                <th>{translations.itemtype || 'Item Type'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewData.map((item, index) => {
                                                const code = item.itemcode || generateItemCode(item.itemname);
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td><span className="ozui_csv-code-preview">{code}</span></td>
                                                        <td>{item.itemname}</td>
                                                        <td>{item.manufacturer || '-'}</td>
                                                        <td>{item.category || '-'}</td>
                                                        <td>{item.itemtype || '-'}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {previewData.length >= 5 && (
                                        <div className="ozui_csv-preview-more">+ more items...</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="ozui_modal-footer">
                    <button className="ozui-btn ozui-btn-secondary" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                        Cancel
                    </button>
                    <button 
                        className="ozui-btn ozui-btn-primary" 
                        onClick={handleUpload}
                        disabled={loading || !selectedFile}
                    >
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                {translations.uploading || 'Uploading...'}
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faUpload} />
                                {translations.csvUpload || 'Upload CSV'}
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

// Bulk Add Modal Component
const BulkAddModal = ({ isOpen, onClose, onBulkAdd, translations, loading }) => {
    const [bulkData, setBulkData] = useState('');

    if (!isOpen) return null;

    const handleSubmit = () => {
        const lines = bulkData.split('\n').filter(line => line.trim());
        const items = lines.map(line => {
            const parts = line.split(',').map(s => s.trim());
            return {
                itemcode: parts[0] || '',
                itemname: parts[1] || '',
                manufacturer: parts[2] || '',
                category: parts[3] || '',
                itemtype: parts[4] || ''
            };
        }).filter(item => item.itemcode && item.itemname);
        
        onBulkAdd(items);
    };

    return (
        <div className="ozui_modal-overlay ozui_modal-lg" onClick={onClose}>
            <div className="ozui_modal" onClick={e => e.stopPropagation()}>
                <div className="ozui_modal-header">
                    <h3>{translations.bulkAdd || 'Bulk Add Items'}</h3>
                    <button className="ozui_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui_modal-body">
                    <div className="ozui_bulk-info">
                        <p>Enter items in CSV format: <strong>code, name, manufacturer, category, itemtype</strong></p>
                        <p>Each item on a new line.</p>
                        <div className="ozui_bulk-example">
                            <strong>Example:</strong>
                            <pre>
                                MED001, Paracetamol 500mg, GSK, Pain Relief, Tablet<br />
                                MED002, Ibuprofen 400mg, Pfizer, Pain Relief, Capsule<br />
                                MED003, Amoxicillin 250mg, Novartis, Antibiotics, Syrup
                            </pre>
                        </div>
                    </div>
                    <textarea
                        className="ozui_bulk-textarea"
                        value={bulkData}
                        onChange={(e) => setBulkData(e.target.value)}
                        placeholder="Enter items here..."
                        rows={10}
                    />
                </div>
                <div className="ozui_modal-footer">
                    <button className="ozui-btn ozui-btn-secondary" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                        Cancel
                    </button>
                    <button 
                        className="ozui-btn ozui-btn-primary" 
                        onClick={handleSubmit}
                        disabled={loading || !bulkData.trim()}
                    >
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                Adding...
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faUpload} />
                                Add Items
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

// Generate item code: first 4 characters of item name + 4 random numbers
const generateItemCode = (itemName) => {
    if (!itemName) return '';
    let prefix = itemName.substring(0, 4).toUpperCase().replace(/\s/g, '');
    while (prefix.length < 4) {
        prefix += 'X';
    }
    const numbers = Math.floor(1000 + Math.random() * 9000);
    return `${prefix}${numbers}`;
};

// Generate unique code avoiding duplicates
const generateUniqueCode = (itemName, existingCodes) => {
    let code = generateItemCode(itemName);
    let counter = 0;
    while (existingCodes.includes(code) && counter < 100) {
        const numbers = Math.floor(1000 + Math.random() * 9000);
        const prefix = itemName.substring(0, 4).toUpperCase().replace(/\s/g, '');
        code = `${prefix}${numbers}`;
        counter++;
    }
    return code;
};

// Capitalize each word in a string (Title Case) - with special handling for categories
const toTitleCase = (str) => {
    if (!str) return '';
    // Convert underscores and hyphens to spaces first
    str = str.replace(/[_-]/g, ' ');
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

// Format category label for display (convert snake_case to Title Case)
const formatCategoryLabel = (category) => {
    if (!category) return '';
    return toTitleCase(category);
};

// Searchable Dropdown Component - FIXED for click selection
const SearchableDropdown = ({ 
    label, 
    icon, 
    value, 
    onChange, 
    options, 
    placeholder, 
    translations, 
    disabled = false,
    onSearch,
    loading = false,
    allowCustom = true
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);

    // Find if the current value exists in options
    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || value || '';

    useEffect(() => {
        setSearchTerm(displayValue);
    }, [displayValue]);

    const filteredOptions = searchTerm.trim() === ''
        ? options
        : options.filter(opt =>
            opt.label.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
        // Blur the input to remove focus
        if (inputRef.current) {
            inputRef.current.blur();
        }
    };

    // Handle custom value input
    const handleInputChange = (e) => {
        const val = e.target.value;
        setSearchTerm(val);
        setIsOpen(true);
        
        // Check if the typed value matches any option
        const matchedOption = options.find(opt => 
            opt.label.toLowerCase() === val.toLowerCase()
        );
        
        if (matchedOption) {
            onChange(matchedOption.value);
        } else {
            if (allowCustom && val.trim()) {
                const formattedValue = toTitleCase(val);
                onChange(formattedValue);
            } else {
                onChange('');
            }
        }
        
        if (onSearch) onSearch(val);
    };

    // Handle focus - open dropdown
    const handleFocus = () => {
        setIsOpen(true);
    };

    // Handle blur - close dropdown with delay to allow click events
    const handleBlur = () => {
        // Use setTimeout to allow click events to fire first
        setTimeout(() => {
            setIsOpen(false);
        }, 200);
    };

    // Handle click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Prevent dropdown from closing when clicking inside it
    const handleDropdownClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className="ozui-searchable-dropdown-wrapper" ref={wrapperRef}>
            <div className="ozui-input-wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                    <span className="ozui-optional-label">({translations.optional || 'Optional'})</span>
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
            </div>

            {isOpen && (
                <div 
                    className="ozui-searchable-dropdown-menu" 
                    ref={dropdownRef}
                    onClick={handleDropdownClick}
                >
                    {loading ? (
                        <div className="ozui-dropdown-loading">
                            <FontAwesomeIcon icon={faSpinner} spin />
                            Loading...
                        </div>
                    ) : filteredOptions.length > 0 ? (
                        <>
                            {filteredOptions.map(opt => (
                                <div
                                    key={opt.value}
                                    className={`ozui-dropdown-option ${value === opt.value ? 'ozui-selected' : ''}`}
                                    onMouseDown={(e) => {
                                        e.preventDefault(); // Prevent blur from firing
                                        handleSelect(opt);
                                    }}
                                >
                                    {opt.label}
                                </div>
                            ))}
                            {allowCustom && searchTerm.trim() && !filteredOptions.find(opt => 
                                opt.label.toLowerCase() === searchTerm.toLowerCase()
                            ) && (
                                <div 
                                    className="ozui-dropdown-option ozui-custom-option"
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        const formattedValue = toTitleCase(searchTerm.trim());
                                        onChange(formattedValue);
                                        setSearchTerm(formattedValue);
                                        setIsOpen(false);
                                    }}
                                >
                                    <span className="ozui-custom-option-label">
                                        {translations.addCustomValue || 'Add'} "{toTitleCase(searchTerm.trim())}"
                                    </span>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div className="ozui-dropdown-empty">
                                {translations.noOptions || 'No options found'}
                            </div>
                            {allowCustom && searchTerm.trim() && (
                                <div 
                                    className="ozui-dropdown-option ozui-custom-option"
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        const formattedValue = toTitleCase(searchTerm.trim());
                                        onChange(formattedValue);
                                        setSearchTerm(formattedValue);
                                        setIsOpen(false);
                                    }}
                                >
                                    <span className="ozui-custom-option-label">
                                        {translations.addCustomValue || 'Add'} "{toTitleCase(searchTerm.trim())}"
                                    </span>
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

const AddPharmacyItem = () => {
    const { user } = useAuth();
    
    const itemCodeInputRef = useRef(null);
    const itemNameInputRef = useRef(null);
    
    const initialFormData = {
        itemcode: '',
        itemname: '',
        manufacturer: '',
        category: '',
        itemtype: '',
    };
    
    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [translations, setTranslations] = useState({});
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [currentThemeColor, setCurrentThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    const [showItemsList, setShowItemsList] = useState(false);
    const [itemsList, setItemsList] = useState([]);
    const [loadingItems, setLoadingItems] = useState(false);
    const [showBulkAdd, setShowBulkAdd] = useState(false);
    const [bulkLoading, setBulkLoading] = useState(false);
    const [showCSVUpload, setShowCSVUpload] = useState(false);
    const [csvLoading, setCsvLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [existingItemCodes, setExistingItemCodes] = useState([]);
    
    // Manufacturer, Category, and Item Type options from database
    const [manufacturerOptions, setManufacturerOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [itemTypeOptions, setItemTypeOptions] = useState([]);
    const [loadingManufacturers, setLoadingManufacturers] = useState(false);
    const [loadingCategories, setLoadingCategories] = useState(false);
    const [loadingItemTypes, setLoadingItemTypes] = useState(false);
    const [manufacturerSearchTerm, setManufacturerSearchTerm] = useState('');
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [itemTypeSearchTerm, setItemTypeSearchTerm] = useState('');
    
    const isSubmittingRef = useRef(false);
    const toastTimerRef = useRef(null);
    const formRef = useRef(null);
    const submitButtonRef = useRef(null);
    const draftsDropdownRef = useRef(null);

    // Auto-focus on item name input when form is opened
    useEffect(() => {
        if (itemNameInputRef.current) {
            itemNameInputRef.current.focus();
        }
    }, []);

    // Fetch manufacturers, categories, and item types from database
    const fetchManufacturers = async () => {
        setLoadingManufacturers(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_manufacturers'
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                const options = data.data.map(m => ({ 
                    value: m, 
                    label: toTitleCase(m) 
                }));
                setManufacturerOptions(options);
            }
        } catch (error) {
            console.error('Error fetching manufacturers:', error);
        } finally {
            setLoadingManufacturers(false);
        }
    };

    const fetchCategories = async () => {
        setLoadingCategories(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_categories'
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                const options = data.data.map(c => ({ 
                    value: c, 
                    label: formatCategoryLabel(c) 
                }));
                setCategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        } finally {
            setLoadingCategories(false);
        }
    };

    const fetchItemTypes = async () => {
        setLoadingItemTypes(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_itemtypes'
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                const options = data.data.map(t => ({ 
                    value: t, 
                    label: toTitleCase(t) 
                }));
                setItemTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching item types:', error);
        } finally {
            setLoadingItemTypes(false);
        }
    };

    // Draft Management Functions
    const saveDraft = () => {
        if (!formData.itemcode && !formData.itemname) {
            showToast('warning', 'Cannot save empty draft');
            return;
        }
        
        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...formData,
            savedAt: new Date().toISOString()
        };
        
        const existingDrafts = JSON.parse(localStorage.getItem('pharmacy_item_drafts') || '[]');
        existingDrafts.unshift(draft);
        const limitedDrafts = existingDrafts.slice(0, 20);
        localStorage.setItem('pharmacy_item_drafts', JSON.stringify(limitedDrafts));
        
        showToast('success', translations.draftSaved || 'Draft saved successfully!');
        loadDrafts();
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('pharmacy_item_drafts') || '[]');
        setSavedDrafts(drafts);
    };

    const loadDraft = (draft) => {
        setFormData({
            itemcode: draft.itemcode || '',
            itemname: draft.itemname || '',
            manufacturer: draft.manufacturer || '',
            category: draft.category || '',
            itemtype: draft.itemtype || '',
        });
        setCategorySearchTerm(draft.category || '');
        setItemTypeSearchTerm(draft.itemtype || '');
        setManufacturerSearchTerm(draft.manufacturer || '');
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('pharmacy_item_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('pharmacy_item_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', 'Draft deleted successfully!');
    };

    useEffect(() => {
        loadDrafts();
        fetchManufacturers();
        fetchCategories();
        fetchItemTypes();
        fetchItems();
    }, []);

    // Click outside for drafts dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ show: true, type, message });
        toastTimerRef.current = setTimeout(() => {
            setToast({ show: false, type: '', message: '' });
        }, 3000);
    }, []);

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
            isSubmittingRef.current = false;
        };
    }, []);

    // ============================================
    // THEME COLOR AUTO-SYNC - FIXED VERSION
    // ============================================
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }
        
        // Apply to document root
        document.documentElement.style.setProperty('--ozui-primary', color);
        document.documentElement.style.setProperty('--ozui-primary-dark', color);
        document.documentElement.style.setProperty('--ozui-primary-light', color);
        
        // Calculate RGB values for orb animations
        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }
        
        // Update orb styles
        let style = document.getElementById('dynamic-orb-styles');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-orb-styles';
            document.head.appendChild(style);
        }
        
        style.textContent = `
            .ozui-header-bg-animation .gradient-orb.orb-1 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-2 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-3 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-4 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
            }
            .ozui-header-bg-animation .gradient-orb.orb-5 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
            }
        `;
        
        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);
        
        // Listen for storage changes from other tabs/windows
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme' && e.newValue) {
                applyTheme(e.newValue);
            }
        };
        
        // Listen for custom theme change events
        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };
        
        // Listen for theme changes from other components in the same window
        const handleThemeUpdate = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };
        
        // MutationObserver to detect changes to the document's style
        const observer = new MutationObserver(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentThemeColor) {
                applyTheme(storedTheme);
            }
        });
        
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['style']
        });
        
        // Also observe the document head for style changes
        const headObserver = new MutationObserver(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentThemeColor) {
                applyTheme(storedTheme);
            }
        });
        
        headObserver.observe(document.head, {
            childList: true,
            subtree: true
        });
        
        // Poll for changes (fallback)
        const pollInterval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentThemeColor) {
                applyTheme(storedTheme);
            }
        }, 500);
        
        // Add event listeners
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);
        window.addEventListener('themeUpdate', handleThemeUpdate);
        
        // Also listen for click events on theme selector buttons
        const handleThemeButtonClick = () => {
            setTimeout(() => {
                const storedTheme = localStorage.getItem('ourzest_theme');
                if (storedTheme && storedTheme !== currentThemeColor) {
                    applyTheme(storedTheme);
                }
            }, 100);
        };
        
        document.addEventListener('click', handleThemeButtonClick);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            window.removeEventListener('themeUpdate', handleThemeUpdate);
            document.removeEventListener('click', handleThemeButtonClick);
            observer.disconnect();
            headObserver.disconnect();
            clearInterval(pollInterval);
        };
    }, [applyTheme, currentThemeColor]);

    // ============================================
    // DARK MODE SYNC
    // ============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);
            
            const container = document.querySelector('.ozui-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('ozui-dark');
                } else {
                    container.classList.remove('ozui-dark');
                }
            }
            
            if (isDarkMode) {
                document.body.classList.add('ozui-dark');
                document.documentElement.classList.add('ozui-dark');
            } else {
                document.body.classList.remove('ozui-dark');
                document.documentElement.classList.remove('ozui-dark');
            }
        };
        
        syncDarkMode();
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };
        
        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                
                const container = document.querySelector('.ozui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozui-dark');
                    } else {
                        container.classList.remove('ozui-dark');
                    }
                }
                
                if (isDark) {
                    document.body.classList.add('ozui-dark');
                    document.documentElement.classList.add('ozui-dark');
                } else {
                    document.body.classList.remove('ozui-dark');
                    document.documentElement.classList.remove('ozui-dark');
                }
            } else {
                syncDarkMode();
            }
        };
        
        const pollInterval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 500);
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(pollInterval);
        };
    }, [darkMode]);

    // ============================================
    // LANGUAGE SYNC
    // ============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await itemTranslator.getTranslations(lang);
            setTranslations(trans);
        };
        
        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };
        
        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };
        
        loadTranslations(currentLanguage);
        
        const pollInterval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 500);
        
        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);
        
        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(pollInterval);
        };
    }, [currentLanguage]);

    // ============================================
    // RTL DIRECTION SYNC
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozui-container');
        
        if (container) {
            if (isRTL) {
                container.classList.add('ozui-rtl');
                container.classList.remove('ozui-ltr');
            } else {
                container.classList.add('ozui-ltr');
                container.classList.remove('ozui-rtl');
            }
        }
        
        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // ============================================
    // API FUNCTIONS - All items are added as ADMIN
    // ============================================
    const fetchItems = async () => {
        setLoadingItems(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_records'
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setItemsList(data.data || []);
                const codes = (data.data || []).map(item => item.itemcode);
                setExistingItemCodes(codes);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        } finally {
            setLoadingItems(false);
        }
    };

    const searchItems = async (term) => {
        setLoadingItems(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'search',
                    search: term
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setItemsList(data.data || []);
            }
        } catch (error) {
            console.error('Error searching items:', error);
        } finally {
            setLoadingItems(false);
        }
    };

    const submitItem = async (submitData) => {
        if (isSubmittingRef.current) return false;
        isSubmittingRef.current = true;

        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'add',
                    itemcode: submitData.itemcode,
                    itemname: submitData.itemname,
                    manufacturer: submitData.manufacturer || null,
                    category: submitData.category || null,
                    itemtype: submitData.itemtype || null
                })
            });

            const data = await response.json();

            if (data.status === 'success') {
                showToast('success', translations.itemAdded || 'Item saved successfully!');
                setFormData(initialFormData);
                setCategorySearchTerm('');
                setManufacturerSearchTerm('');
                setItemTypeSearchTerm('');
                setErrors({});
                fetchItems();
                fetchManufacturers();
                fetchCategories();
                fetchItemTypes();
                return true;
            } else if (data.status === 'duplicate') {
                showToast('error', data.message || translations.codeExists || 'Item code already exists');
                setErrors({ itemcode: data.message || 'Item code already exists' });
                return false;
            } else {
                showToast('error', data.message || translations.failedAdd || 'Failed to save item');
                return false;
            }
        } catch (error) {
            console.error('Submit error:', error);
            showToast('error', translations.networkError || 'Network error occurred');
            return false;
        } finally {
            setTimeout(() => {
                isSubmittingRef.current = false;
                setLoading(false);
            }, 1000);
        }
    };

    const deleteItem = async (itemId) => {
        if (!window.confirm(translations.deleteConfirm || 'Are you sure you want to delete this item?')) return;
        
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete',
                    id: itemId
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', translations.itemDeleted || 'Item deleted successfully');
                fetchItems();
                fetchManufacturers();
                fetchCategories();
                fetchItemTypes();
            } else {
                showToast('error', data.message || translations.failedDelete || 'Failed to delete item');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error occurred');
        }
    };

    const handleBulkAdd = async (items) => {
        if (!items.length) {
            showToast('warning', 'No valid items to add');
            return;
        }
        
        setBulkLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'bulk_add',
                    items: items
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', `${data.added} items added successfully`);
                fetchItems();
                fetchManufacturers();
                fetchCategories();
                fetchItemTypes();
                setShowBulkAdd(false);
            } else {
                showToast('error', data.message || 'Failed to add items');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            setBulkLoading(false);
        }
    };

    const handleCSVUpload = async (file) => {
        if (!file) return;
        
        setCsvLoading(true);
        try {
            const reader = new FileReader();
            reader.onload = async (event) => {
                try {
                    const text = event.target.result;
                    const lines = text.split('\n').filter(line => line.trim());
                    
                    let startIndex = 0;
                    const firstLine = lines[0].toLowerCase();
                    if (firstLine.includes('itemcode') || firstLine.includes('itemname') || 
                        firstLine.includes('name') || firstLine.includes('code') || 
                        firstLine.includes('manufacturer') || firstLine.includes('category')) {
                        startIndex = 1;
                    }
                    
                    const items = [];
                    const existingCodes = [...existingItemCodes];
                    
                    for (let i = startIndex; i < lines.length; i++) {
                        const line = lines[i].trim();
                        if (!line) continue;
                        
                        const parts = line.split(',').map(s => s.trim());
                        
                        let itemcode = '';
                        let itemname = '';
                        let manufacturer = '';
                        let category = '';
                        let itemtype = '';
                        
                        if (parts.length === 1) {
                            itemname = parts[0] || '';
                        } else if (parts.length >= 5) {
                            itemcode = parts[0] || '';
                            itemname = parts[1] || '';
                            manufacturer = parts[2] || '';
                            category = parts[3] || '';
                            itemtype = parts[4] || '';
                        } else if (parts.length >= 2) {
                            itemcode = parts[0] || '';
                            itemname = parts[1] || '';
                            if (parts.length >= 3) manufacturer = parts[2] || '';
                            if (parts.length >= 4) category = parts[3] || '';
                        }
                        
                        if (!itemname) continue;
                        
                        itemname = toTitleCase(itemname);
                        if (manufacturer) manufacturer = toTitleCase(manufacturer);
                        if (category) category = toTitleCase(category);
                        if (itemtype) itemtype = toTitleCase(itemtype);
                        
                        if (!itemcode) {
                            itemcode = generateUniqueCode(itemname, existingCodes);
                        } else {
                            let finalCode = itemcode.toUpperCase();
                            let counter = 0;
                            while (existingCodes.includes(finalCode) && counter < 100) {
                                const numbers = Math.floor(1000 + Math.random() * 9000);
                                const prefix = itemname.substring(0, 4).toUpperCase().replace(/\s/g, '');
                                finalCode = `${prefix}${numbers}`;
                                counter++;
                            }
                            itemcode = finalCode;
                        }
                        existingCodes.push(itemcode);
                        
                        items.push({
                            itemcode: itemcode,
                            itemname: itemname,
                            manufacturer: manufacturer || '',
                            category: category || '',
                            itemtype: itemtype || ''
                        });
                    }
                    
                    if (items.length === 0) {
                        showToast('warning', translations.invalidCSV || 'No valid items found in CSV');
                        setCsvLoading(false);
                        return;
                    }
                    
                    const confirmed = window.confirm(
                        `Found ${items.length} items to upload. Click OK to proceed.`
                    );
                    
                    if (!confirmed) {
                        setCsvLoading(false);
                        return;
                    }
                    
                    const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            action: 'bulk_add',
                            items: items
                        })
                    });
                    const data = await response.json();
                    
                    if (data.status === 'success') {
                        showToast('success', `${data.added} items added successfully from CSV`);
                        fetchItems();
                        fetchManufacturers();
                        fetchCategories();
                        fetchItemTypes();
                        setShowCSVUpload(false);
                    } else {
                        showToast('error', data.message || translations.failedUpload || 'Failed to upload items');
                    }
                } catch (error) {
                    console.error('Error parsing CSV:', error);
                    showToast('error', translations.invalidCSV || 'Invalid CSV format');
                } finally {
                    setCsvLoading(false);
                }
            };
            reader.readAsText(file);
        } catch (error) {
            console.error('Error uploading CSV:', error);
            showToast('error', translations.failedUpload || 'Failed to upload items');
            setCsvLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmittingRef.current) return;
        if (!validateForm()) return;
        
        setLoading(true);
        await submitItem(formData);
        setLoading(false);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.itemcode.trim()) {
            newErrors.itemcode = translations.codeRequired || 'Item code is required';
        }
        if (!formData.itemname.trim()) {
            newErrors.itemname = translations.nameRequired || 'Item name is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleClear = () => {
        setFormData(initialFormData);
        setCategorySearchTerm('');
        setManufacturerSearchTerm('');
        setItemTypeSearchTerm('');
        setErrors({});
        showToast('success', translations.draftCleared || 'Form cleared');
        if (itemNameInputRef.current) {
            itemNameInputRef.current.focus();
        }
    };

    const handleEditItem = (item) => {
        setFormData({
            itemcode: item.itemcode || '',
            itemname: item.itemname || '',
            manufacturer: item.manufacturer || '',
            category: item.category || '',
            itemtype: item.itemtype || '',
        });
        setCategorySearchTerm(item.category || '');
        setItemTypeSearchTerm(item.itemtype || '');
        setManufacturerSearchTerm(item.manufacturer || '');
        setShowItemsList(false);
        if (itemNameInputRef.current) {
            itemNameInputRef.current.focus();
        }
    };

    const handleItemNameChange = (e) => {
        let value = e.target.value;
        value = toTitleCase(value);
        
        setFormData(prev => {
            const newCode = generateUniqueCode(value, existingItemCodes);
            return { ...prev, itemname: value, itemcode: newCode };
        });
        if (errors.itemname) setErrors(prev => ({ ...prev, itemname: '' }));
    };

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`ozui-container ${isRTL ? 'ozui-rtl' : 'ozui-ltr'} ${darkMode ? 'ozui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />
            
            <ItemsListModal
                isOpen={showItemsList}
                onClose={() => setShowItemsList(false)}
                items={itemsList}
                translations={translations}
                onEdit={handleEditItem}
                onDelete={deleteItem}
                loading={loadingItems}
            />

            <CSVUploadModal
                isOpen={showCSVUpload}
                onClose={() => setShowCSVUpload(false)}
                onUpload={handleCSVUpload}
                translations={translations}
                loading={csvLoading}
            />

            <BulkAddModal
                isOpen={showBulkAdd}
                onClose={() => setShowBulkAdd(false)}
                onBulkAdd={handleBulkAdd}
                translations={translations}
                loading={bulkLoading}
            />

            <div className="ozui-sticky-header">
                <div className="ozui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozui-header-content">
                    <div className="ozui-header-left">
                        <div className="ozui-header-title">
                            <h1>
                                {translations.addItem || 'Add Item'}
                            </h1>
                            <p>{translations.fillDetails || 'Fill in the item details below'}</p>
                        </div>
                    </div>
                    
                    <div className="ozui-header-right">
                        <div className="ozui-header-actions">
                            <button 
                                className="ozui-action-btn csv-upload-btn" 
                                onClick={() => setShowCSVUpload(true)}
                                title={translations.csvUpload || 'CSV Upload'}
                            >
                                <FontAwesomeIcon icon={faFileCsv} />
                                <span>{translations.csvUpload || 'CSV'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn" 
                                onClick={() => setShowItemsList(true)}
                                title={translations.itemsList || 'Items List'}
                            >
                                <FontAwesomeIcon icon={faList} />
                                <span>{translations.itemsList || 'List'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn" 
                                onClick={() => setShowBulkAdd(true)}
                                title={translations.bulkAdd || 'Bulk Add'}
                            >
                                <FontAwesomeIcon icon={faUpload} />
                                <span>{translations.bulkAdd || 'Bulk'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn clear-draft" 
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearForm || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <span>{translations.clear || 'Clear'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn save-draft" 
                                onClick={saveDraft}
                                disabled={loading}
                                title={translations.saveAsDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>
                            
                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button 
                                    className="ozui-action-btn drafts-btn" 
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>
                                
                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.itemname || draft.itemcode || 'Unnamed Item'}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.itemcode && <span>Code: {draft.itemcode}</span>}
                                                                {draft.manufacturer && <span>Mfr: {draft.manufacturer}</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <form ref={formRef} onSubmit={handleSubmit} className="ozui-form">
                <div className="ozui-form-row">
                    <div className={`ozui-field ${errors.itemcode ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                ref={itemCodeInputRef}
                                type="text"
                                name="itemcode"
                                id="itemcode"
                                value={formData.itemcode}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="itemcode">
                                <FontAwesomeIcon icon={faBarcode} />
                                {translations.itemCode || 'Item Code'} <span>*</span>
                            </label>
                        </div>
                        {errors.itemcode && <small>{errors.itemcode}</small>}
                    </div>

                    <div className={`ozui-field ${errors.itemname ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                ref={itemNameInputRef}
                                type="text"
                                name="itemname"
                                id="itemname"
                                value={formData.itemname}
                                onChange={handleItemNameChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="itemname">
                                <FontAwesomeIcon icon={faTag} />
                                {translations.itemName || 'Item Name'} <span>*</span>
                            </label>
                        </div>
                        {errors.itemname && <small>{errors.itemname}</small>}
                    </div>

                    <div className="ozui-field">
                        <SearchableDropdown
                            label={translations.manufacturer || 'Manufacturer'}
                            icon={faBuilding}
                            value={formData.manufacturer}
                            onChange={(val) => setFormData(prev => ({ ...prev, manufacturer: val }))}
                            options={manufacturerOptions}
                            placeholder={translations.searchManufacturer || 'Type to search manufacturer...'}
                            translations={{
                                noOptions: translations.noManufacturers || 'No manufacturers found',
                                optional: translations.optional || 'Optional',
                                addCustomValue: translations.addCustomValue || 'Add custom value'
                            }}
                            disabled={loading}
                            loading={loadingManufacturers}
                            onSearch={(term) => setManufacturerSearchTerm(term)}
                            allowCustom={true}
                        />
                    </div>

                    <div className="ozui-field">
                        <SearchableDropdown
                            label={translations.category || 'Category'}
                            icon={faListUl}
                            value={formData.category}
                            onChange={(val) => setFormData(prev => ({ ...prev, category: val }))}
                            options={categoryOptions}
                            placeholder={translations.searchCategory || 'Type to search category...'}
                            translations={{
                                noOptions: translations.noCategories || 'No categories found',
                                optional: translations.optional || 'Optional',
                                addCustomValue: translations.addCustomValue || 'Add custom value'
                            }}
                            disabled={loading}
                            loading={loadingCategories}
                            onSearch={(term) => setCategorySearchTerm(term)}
                            allowCustom={true}
                        />
                    </div>

                    <div className="ozui-field">
                        <SearchableDropdown
                            label={translations.itemtype || 'Item Type'}
                            icon={faLayerGroup}
                            value={formData.itemtype}
                            onChange={(val) => setFormData(prev => ({ ...prev, itemtype: val }))}
                            options={itemTypeOptions}
                            placeholder={translations.searchItemType || 'Type to search item type...'}
                            translations={{
                                noOptions: translations.noItemTypes || 'No item types found',
                                optional: translations.optional || 'Optional',
                                addCustomValue: translations.addCustomValue || 'Add custom value'
                            }}
                            disabled={loading}
                            loading={loadingItemTypes}
                            onSearch={(term) => setItemTypeSearchTerm(term)}
                            allowCustom={true}
                        />
                    </div>
                </div>
                
                <div className="ozui-form-actions">
                    <button 
                        ref={submitButtonRef}
                        type="submit" 
                        className="ozui-btn ozui-btn-primary" 
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>{translations.adding || 'Adding...'}</span>
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faPlus} />
                                <span>{translations.saveItem || 'Save Item'}</span>
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddPharmacyItem;